import React from "react";
import { listItems } from "../../../../data/features";
import featureImg1 from "../../../../assets/img/hero-img-2.png"
import featureImg2 from "../../../../assets/img/Female.png"
import { tools } from "../../../../data/tools";

export default function Features() {
  return (
    <>
    <div className="wg-create-design pt-130">
      <div className="section-container">
        <div className="row">
          <div className="col-md-6">
            <div className="image">
              <div className="rectangle" />
              <img
                className="img-01"
                src={featureImg1}
                width={310}
                height={470}
                alt=""
              />
              <div className="place">
                  <svg xmlns="http://www.w3.org/2000/svg" width={65} height={80} viewBox="0 0 14 14">
                    <path fill="#F8601D" fillRule="evenodd" d="M9.997.22a.75.75 0 0 1 .819-.163l2.127.882a.75.75 0 0 1 .408.977l-.869 2.127a.75.75 0 0 1-1.386.006l-.343-.82L2.115 6.92a.75.75 0 1 1-.59-1.38l8.649-3.695l-.337-.805a.75.75 0 0 1 .16-.82m2.753 5.26a1 1 0 0 1 1 1v7a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5v-7a1 1 0 0 1 1-1zM8.457 7.272a1 1 0 0 0-.707-.292h-1.5a1 1 0 0 0-1 1v5.5a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .5-.5v-5.5a1 1 0 0 0-.293-.708M2.75 8.48a1 1 0 0 1 1 1v4a.5.5 0 0 1-.5.5H.75a.5.5 0 0 1-.5-.5v-4a1 1 0 0 1 1-1z" clipRule="evenodd"></path>
                  </svg>
              </div>
              <img
                className="img-02"
                src={featureImg2}
                width={345}
                height={345}
                alt=""
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="content">
              <div className="heading-section wow fadeInUp style-2">
                <h6>Empower Your Learning Journey</h6>
                <div className="main-title">
                    All the Essential Tools for <br /> Growth in {" "}
                  <span className="animation-text">One Platform</span>
                </div>
              </div>
              <p className="">
                  
                  At Avaxia, we believe in transforming the way you learn and train your team. Our platform offers immersive, hands-on VR training experiences, allowing learners to engage deeply and develop the skills they need in today’s fast-moving business world.
              </p>
              <ul className="list-item">
                {listItems.map((elm, i) => (
                  <li key={i}>
                    <i className="icon-tick" />
                    {elm.text}
                  </li>
                ))}
              </ul>
              <a href="#" className="tf-button type-1">
                <span>Enroll Now</span>
                <i className="icon-arrow-right2" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div className="list-tool">
        <div className="section-container">
          <div className="row justify-center">
            <div className="col-12">
              <div className="heading-section text-center wow fadeInUp">
                <h6>Empower Your Learning Journey</h6>
                <div className="main-title">
                  Why Choose  
                  <span className="animation-text"> Avaxia Training Center</span>
                </div>
              </div>
            </div>
            {tools.map((tool, index) => (
              <div className="col-md-5" key={index}>
                <div
                  className={`wg-tool wow fadeInUp`}
                  data-wow-delay={tool.delay}
                >
                  <div className={`icon ${tool.iconClass}`} />
                  <h3>
                    <a href="#">{tool.title}</a>
                  </h3>
                  <p>{tool.description}</p>
                  <div className="order">{tool.order}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}